var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mfv"}},[_c('div',{staticClass:"page"},[_c('RouterView')],1),_vm._v(" "),_c('Popup'),_vm._v(" "),_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }